import Chip from '@material-ui/core/Chip';
import { Link } from '@backstage/core-components';
import { COLORS } from '@internal/backstage-plugin-hm-common';
import { useNotifications } from '../../../hooks';

type NotificationBadgeProps = {
  withLink?: boolean;
  size?: 'small' | 'medium';
  className?: string;
};

type BadgeProps = {
  withLink?: boolean;
  count: number;
  size: 'small' | 'medium';
  className?: string;
};

const Badge = ({ withLink, count, size, className }: BadgeProps) => (
  <Chip
    size={size}
    label={count > 99 ? '99+' : count}
    className={className}
    style={{
      margin: 0,
      backgroundColor: COLORS.NOTIFICATION,
      cursor: withLink ? 'pointer' : 'default',
    }}
  />
);

export const NotificationBadge = ({
  withLink,
  size = 'medium',
  className,
}: NotificationBadgeProps) => {
  const { count } = useNotifications();

  if (!count) {
    return null;
  }

  return withLink ? (
    <Link
      to="/notifications"
      aria-label="Notifications"
      className={className}
      style={{ cursor: 'pointer', display: 'inline-flex' }}
      underline="none"
    >
      <Badge size={size} count={count} withLink />
    </Link>
  ) : (
    <Badge size={size} count={count} className={className} />
  );
};
